<template>
  <el-container>
    <el-main>
      <div class="home">
        <el-card class="ta-main" v-if="!dataLoaded">
          <div class="ta-header ta-header__main">
            {{$t('feedback.codeLabel')}}
          </div>
          <el-row class="ta-row">
            <el-col :span="20" class="ta-label">
              <el-input v-model="code" class="ta-input"/>
            </el-col>
            <el-col :span="4">
              <el-button @click="getStatistics">
                {{$t('feedback.btnText')}}
              </el-button>
            </el-col>
          </el-row>
          <el-row v-if="error">
            <el-col :span="20" class="ta-label ta-label__error">
              {{error}}
            </el-col>
          </el-row>
        </el-card>

        <el-card class="ta-main" v-else>

          <div class="ta-header ta-header__main">
            {{$t('feedback.title')}}
          </div>

          <el-table
            :data="data"
            :default-sort = "{prop: 'date', order: 'descending'}"
            style="width: 100%">
            <el-table-column
              prop="date"
              sortable
              :label="$t('feedback.dateTitle')">
              <template slot-scope="scope">
                {{formatTime(scope.row.date)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('feedback.nameTitle')">
            </el-table-column>
<!--            <el-table-column-->
<!--              prop="email"-->
<!--              :label="$t('feedback.emailTitle')">-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="phone"-->
<!--              :label="$t('feedback.phoneTitle')">-->
<!--            </el-table-column>-->
            <el-table-column
              prop="feedback"
              :label="$t('feedback.feedbackTitle')">
              <template slot-scope="scope">
                <el-button size="mini"
                           @click="showFeedback(scope.row)">
                  {{$t('feedback.feedbackBtnText')}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

        </el-card>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import I18nMixin from '../i18n/i18n_mixin'

export default {
  name: 'Statistics',
  mixins: [I18nMixin],
  data () {
    return {
      id: 'stats_chart',
      data: [],
      code: null,
      dataLoaded: false,
      error: null
    }
  },
  computed: {},
  methods: {
    getStatistics () {
      this.error = null
      axios.post('/api/v1/feedback/all', this.code, { headers: { 'Content-Type': 'text/plain' } })
        .then(r => r.data)
        .then(d => {
          this.data = d
          this.dataLoaded = true
        })
        .catch(() => {
          this.error = this.$t('feedback.loadingError')
        })
    },
    showFeedback (feedback) {
      this.$alert(`
          <div class="ta-row el-row">
            <div class="ta-label el-col el-col-8">
              <b>${this.$t('modals.feedback.emailLabel')}</b>
            </div>
            <div class="el-col el-col-16">
              ${feedback.email}
            </div>
          </div>

          <div class="ta-row el-row">
            <div class="ta-label el-col el-col-8">
              <b>${this.$t('modals.feedback.phoneLabel')}</b>
            </div>
            <div class="el-col el-col-16">
              ${feedback.phone}
            </div>
          </div>

          <div class="ta-row el-row">
            <div class="ta-label el-col el-col-24">
              <b>${this.$t('modals.feedback.displayFeedbackLabel')}</b>
            </div>
          </div>

          <div class="ta-row el-row">
            <div class="el-col el-col-24">
              ${feedback.feedback}
            </div>
          </div>
      `, feedback.name, {
        dangerouslyUseHTMLString: true
      })
    },
    formatTime (date) {
      return moment(date).format('D.MM.YYYY HH:mm')
    }
  },
  mounted () {
    const locale = this.$route.query.lang
    if (this.isLocaleSupported(locale)) {
      this.setLocale(locale)
    }
  }
}
</script>

<style lang="scss">
  .home {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    flex-wrap: wrap;
    align-content: stretch;

    .ta-main {
      background: #F1F6E4;
      margin: 10pt;
      max-width: 800px;
      flex-basis: 600px;
      flex-grow: 1;

      @media all and (max-width: 500px) {
        margin-left: 0;
        margin-right: 0;
      }

      .ta-row {
        padding: 5px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        vertical-align: middle;

        &:nth-of-type(even) {
          background: #E0F2D9;
        }

        &:nth-of-type(odd) {
          background: #F1F6E4;
        }

        &__inner {
          padding-left: 0;
          padding-right: 0;
        }

        .ta-input {
          width: 100%;
        }
      }

      .ta-row-block {
        padding: 5px 20px;
        background: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        vertical-align: middle;

        & + .ta-row-block {
          border-top: 1px solid;
        }
      }
    }
  }

  .ta-label {
    text-align: start;

    &__bold {
      font-weight: bold;
    }

    &__error {
      color: red;
      font-weight: bold;
    }

    &__centered {
      display: flex;
      justify-content: center;
    }
  }

  .ta-header {
    margin-top: 10pt;
    padding-bottom: 20px;
    font-weight: bold;
    font-size: large;

    &__main {
      font-size: x-large;
    }
  }

  .ta-footer {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }

  .ta-chart-header {
    display: flex;
    justify-content: center;
    font-size: 15pt;
    padding: 10pt;

    &__with-hint {
      padding-bottom: 3pt;
    }

    &__small {
      padding-top: 0;
      padding-bottom: 10pt;
      font-size: 10pt;
      font-weight: lighter;
    }
  }

</style>
